/**
 * Application Names
 * @type {{Community: string, CityCenter: string}}
 */
const names = {
  // Community: "Community",
  CityCenter: "CityCenter"
};

/**
 * Application Titles
 * @type {{Community: string, CityCenter: string}}
 */
const titles = {
  // Community: "Community",
  CityCenter: "City Center"
};

/**
 * Application Icons
 * @type {{Community: string}}
 * @type {{EmployeeAccess: string}}
 */
const icons = {
  // Community: "mdi-domain",
  CityCenter: "mdi-account-key-outline",
  EmployeeAccess: "mdi-account-circle-outline",
  Financials: "",
  Payroll: ""
};

/**
 * Applications
 * @type [{icon: string, name: string, title: string}]
 */
const apps = [
  // {
  //   title: titles.Community,
  //   icon: icons.Community,
  //   name: names.Community
  // },
  {
    title: titles.CityCenter,
    icon: icons.CityCenter,
    name: names.CityCenter
  }
];

export { names, titles, icons, apps };
